module.exports = __webpack_public_path__ + "6bb660c78f20ea5c99844a7f0333db86.jpg";